class FormValidation {
  // HELPERS

  validateInputs(form, displayErrorMessages) {
    jQuery(form)
      .find(":input")
      .each((i, input) => {
        this.addValidityMessage(input, displayErrorMessages);
      });
    spSelectsIn(form).forEach((select) => this.addValidityMessage(select, displayErrorMessages));

    return form;
  }

  validateRequiredInputs(form, displayErrorMessages) {
    jQuery(form)
      .find("input[required]")
      .each((i, input) => {
        this.addValidityMessage(input, displayErrorMessages);
      });

    return form;
  }

  willGroupValidate(inputGroup) {
    var willValidate = true;
    inputGroup.each(checkInputValidity);

    return willValidate;

    function checkInputValidity(index, input) {
      if (!input.validity.valid) {
        willValidate = false;
      }
    }
  }

  addValidityMessage(input, displayErrorMessages) {
    var formAttemptedToSubmit = jQuery(input).closest("form").hasClass("submit-attempted");
    this.removeValidityMessage(input);
    jQuery(input).addClass("blurred");

    if (input.validity.valueMissing && (displayErrorMessages || formAttemptedToSubmit)) {
      jQuery(input)
        .parent()
        .after(
          '<dd class="validation-error-message validation-required-message">' + Sparkle.t("required_field") + "</dd>",
        );
    } else if (input.validity.valueMissing && !formAttemptedToSubmit) {
      jQuery(input).parent().addClass("invalid-on-submit");
    } else if (input.validationMessage) {
      jQuery(input)
        .parent()
        .after('<dd class="validation-error-message"> ' + input.validationMessage + "</dd>");
    } else if (input.validity.typeMismatch || input.validity.patternMismatch || input.validity.customError) {
      jQuery(input)
        .parent()
        .after('<dd class="validation-error-message">' + Sparkle.t("incorrect_format") + "</dd>");
    }
  }

  removeAllValidityMessages(form) {
    jQuery(form)
      .find(":input")
      .each((i, input) => {
        this.removeValidityMessage(input);
      });
    spSelectsIn(form).forEach((select) => this.removeValidityMessage(select));
  }

  removeValidityMessage(input) {
    jQuery(input).parent().nextAll(".validation-error-message").remove();
    jQuery(input).parent().removeClass("invalid-on-submit");
    jQuery(input).removeClass("blurred");
  }
}

function spSelectsIn(form) {
  const roots = form.jquery ? form.toArray() : [form];

  return roots.flatMap((root) => Array.from(root.querySelectorAll("sp-select")));
}

window.FormValidation = FormValidation;
